import {
  NewsletterClientDriver,
  NewsletterSubscribeOptions,
} from "@made-people/grease-newsletter";
import { AxiosInstance } from "axios";
import { z } from "zod";
import { MmEmarsysConfig } from "./mm-emarsys-config-provider";

const mmEmarsysNewsletterOptionsSchema = z.object({
  phoneNumber: z.string().optional(),
});

export type MmEmarsysNewsletterOptions = z.infer<
  typeof mmEmarsysNewsletterOptionsSchema
>;

/**
 * This class implements Miss Mary's custom emarsys endpoint for subscribing
 * to the newsletter. That's why it's prefixed with 'Mm'.
 */
export class MmEmarsysNewsletterClient
  implements NewsletterClientDriver<MmEmarsysNewsletterOptions>
{
  constructor(
    private readonly client: AxiosInstance,
    private readonly config: MmEmarsysConfig,
  ) {}

  async subscribe(
    options: NewsletterSubscribeOptions<MmEmarsysNewsletterOptions>,
  ): Promise<void> {
    const { email, attributes } = options;
    const parsedData = mmEmarsysNewsletterOptionsSchema.safeParse(attributes);
    if (!parsedData.success) {
      throw new Error(
        `[MmEmarsysNewsletterClient]: Invalid input data for Emarsys newsletter, ${JSON.stringify(
          parsedData.error.errors,
        )}`,
      );
    }

    await this.client.put("/emarsys/subscribe", {
      email,
      language: this.config.language,
      country: this.config.country,
      optinMethod: this.config.optinMethod,
      ...parsedData.data,
    });
  }

  async unsubscribe() //options: NewsletterUnsubscribeOptions<MmEmarsysNewsletterOptions>,
  : Promise<void> {
    throw new Error("Unsubscribe method not implemented");
  }
}
